import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionTitle } from "./Reveal";
import { SERVICES, WHATSAPP } from "@/data/site";

const Card = ({ s, i, featured }) => (
  <motion.a
    href={`${WHATSAPP.split("?")[0]}?text=${encodeURIComponent(`Merhaba, ${s.name} için randevu almak istiyorum.`)}`}
    target="_blank" rel="noopener noreferrer"
    data-testid={`service-card-${s.id}`}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
    className={`group relative rounded-[1.75rem] overflow-hidden card-soft ${featured ? "md:col-span-2 lg:col-span-2 lg:row-span-2" : ""}`}
  >
    <div className={`relative overflow-hidden ${featured ? "aspect-[4/3] lg:aspect-auto lg:h-full lg:min-h-[520px]" : "aspect-[4/3]"}`}>
      <img src={s.image} alt={`${s.seo} – ${s.desc}`} loading="lazy" className="w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-110" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a]/85 via-[#2a081a]/30 to-transparent" />
      <div className="absolute top-5 left-5 text-[11px] tracking-[0.2em] uppercase text-white/80 font-medium">0{i + 1} · {s.seo}</div>
      <div className="absolute top-5 right-5 w-11 h-11 rounded-full bg-white/15 backdrop-blur-md border border-white/30 flex items-center justify-center text-white transition-[transform,background-color] duration-500 group-hover:bg-white group-hover:text-[#e6007e] group-hover:rotate-45">
        <ArrowUpRight size={18} />
      </div>
      <div className="absolute bottom-0 inset-x-0 p-6 lg:p-8">
        <h3 className={`font-semibold text-white tracking-tight ${featured ? "text-3xl lg:text-4xl" : "text-2xl"}`}>{s.name}</h3>
        <p className="mt-2 text-sm md:text-base text-pink-100/85 leading-relaxed max-w-md">{s.desc}</p>
        <span className="mt-4 inline-block text-xs font-medium text-pink-200 opacity-0 translate-y-2 transition-[opacity,transform] duration-500 group-hover:opacity-100 group-hover:translate-y-0">Randevu için WhatsApp →</span>
      </div>
    </div>
  </motion.a>
);

export const Services = () => (
  <section id="hizmetler" className="relative py-28 lg:py-36 bg-grad-blush grain" data-testid="services-section">
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
        <SectionTitle eyebrow="Hizmetlerimiz" title={<>Esenyurt'ta <span className="text-gradient">premium</span> güzellik hizmetleri</>} desc="Protez tırnaktan cilt bakımına kadar her uygulamada hijyen, kalite ve estetik önceliğimizdir." />
        <Reveal delay={0.2}>
          <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" data-testid="services-whatsapp-button" className="btn-grad-dark inline-flex items-center gap-2 text-white font-semibold px-7 py-4 rounded-full">Randevu Al <ArrowUpRight size={18} /></a>
        </Reveal>
      </div>
      <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
        {SERVICES.map((s, i) => <Card key={s.id} s={s} i={i} featured={i === 0} />)}
      </div>
    </div>
  </section>
);
